import { useEffect, useState } from "react";
import SEO from "../components/SEO";
import Hero from "../components/sections/Hero";
import AccidentTypesGrid from "../components/sections/AccidentTypesGrid";
import HowItWorks from "../components/sections/HowItWorks";
import TrustSection from "../components/sections/TrustSection";
import OurPromise from "../components/sections/OurPromise";
import Testimonials from "../components/sections/Testimonials";
import FAQAccordion from "../components/sections/FAQAccordion";
import CitiesPreview from "../components/sections/CitiesPreview";
import CTASection from "../components/sections/CTASection";
import { getAccidentTypes, getTestimonials, getFAQs } from "../lib/api";

export default function Home() {
  const [data, setData] = useState({ types: [], testimonials: [], faqs: [] });
  useEffect(() => {
    Promise.all([getAccidentTypes(), getTestimonials(), getFAQs()])
      .then(([types, testimonials, faqs]) =>
        setData({ types, testimonials, faqs: faqs.slice(0, 6) })
      )
      .catch(() => {});
  }, []);

  const schema = {
    "@context": "https://schema.org",
    "@type": "LegalService",
    "name": "Ohio Accident Aid",
    "description": "Free 24/7 help for accident victims in Ohio. Connect with local attorneys for car, truck, motorcycle, and other accident claims.",
    "url": typeof window !== "undefined" ? window.location.origin : "",
    "telephone": "+1-216-245-5967",
    "areaServed": { "@type": "State", "name": "Ohio" },
    "priceRange": "Free consultation",
  };

  const hasRealTestimonials = data.testimonials && data.testimonials.length > 0;

  return (
    <>
      <SEO
        title="Ohio Accident Aid | Free 24/7 Help for Accident Victims in Ohio"
        description="Hurt in an Ohio accident? Free, confidential help connecting you with experienced local attorneys. Available 24/7. No fees unless you win."
        schema={schema}
      />
      <Hero />
      <AccidentTypesGrid items={data.types} />
      <HowItWorks />
      <TrustSection />
      {hasRealTestimonials ? <Testimonials items={data.testimonials} /> : <OurPromise />}
      <CitiesPreview />
      <FAQAccordion items={data.faqs} />
      <CTASection />
    </>
  );
}
